import { injectReducer } from '../../store/reducers';
import { injectSagas } from '../../store/sagas';

export default store => ({
  path : '/admin/conferences',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const Counter = require('./containers/AdminContainer').default;
      let reducer;
      const sagas = require('sagas/sagas').default;

      const reducerArray = ['conferences', 'newConference'];
      reducerArray.forEach((item) => {
        reducer = require(`reducers/${item}`).default; // eslint-disable-line
        injectReducer(store, { key: item, reducer });
      });

      injectSagas(store, { key: 'sagas', sagas });

      cb(null, Counter);
    }, 'admin');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/Admin/index.js